<template>
    <inertia-link :href="href" :method="method" class="link bg-transparent px-3 py-1 rounded inline-block hover:shadow" @click="setLoading(href)">
        <span v-if="icon"><i class="fal" :class="(loading == href ? 'fa-spinner fa-spin' : 'fa-' + icon) + (this.$slots.default ? ' mr-1' : '')"></i></span>
        <slot></slot>
    </inertia-link>
</template>

<script>
import Helpers from "@/admin/Mixins/GeneralHelpers.js";

export default {
    mixins: [Helpers],

    props: {
        href: null,
        method: null,
        icon: null
    }
};
</script>

<style>
.link {
    transition: all, 0.2s;
}
</style>
